export class ErrorModel {
    "Nombre_Error": string = '';
    "Tipo_Error": string = '';
    "Msg_Error": string = '';
    "State_Error": boolean = false;
  }
  